import createStore from "view-ui-admin/src/utils/create-store";
import Model from "@/models/admin/teachers";

export default createStore({ Model });
